import socketIOClient from 'socket.io-client';
import CONFIG from './config.js';

export default socket => {
	if (!socket) {
		const newSocket = socketIOClient(CONFIG.wsServerUrl, {
			'forceNew': true,
			'force new connection': true,
			transports: ['websocket'],
			upgrade: false,
		});

		console.log('SOCKET CREATED', new Date().toLocaleTimeString());

		return newSocket;
	}
};
